import _ from "lodash";
import querystring from "query-string";
import uuidv4 from 'uuid/v4';

export const awsAvailableRegions = [
    { value: 'us-east-1', label: 'us-east-1 | US East (N. Virginia)' },
    { value: 'us-west-1', label: 'us-west-1 | US West (N. California)' },
    { value: 'us-west-2', label: 'us-west-2 | US West (Oregon)' },
    { value: 'ap-northeast-1', label: 'ap-northeast-1 | Asia Pacific (Tokyo)' },
    { value: 'ap-southeast-2', label: 'ap-northeast-2 | Asia Pacific (Sydney)' },
    { value: 'eu-west-1', label: 'eu-west-1 | EU (Ireland)' },
    { value: 'eu-west-2', label: 'eu-west-2 | EU (London)' },
    { value: 'eu-central-1', label: 'eu-central-1 | EU (Frankfurt)' }
];

export const azureAvailableRegions = [
    { value: 'australiaeast', label: 'Australia East' },
    { value: 'centralus', label: 'Central US' },
    { value: 'eastus', label: 'East US' },
    { value: 'eastus2', label: 'East US 2' },
    { value: 'northeurope', label: 'North Europe' },
    { value: 'southcentralus', label: 'South Central US' },
    { value: 'southeastasia', label: 'Southeast Asia' },
    { value: 'westeurope', label: 'West Europe' },
    { value: 'westus2', label: 'West US 2' },
    { value: 'northcentralus', label: 'North Central US' },
    { value: 'westus', label: 'West US' },
    { value: 'westcentralus', label: 'West Central US' },
    { value: 'canadacentral', label: 'Canada Central' },
    { value: 'canadaeast', label: 'Canada East' },
    { value: 'brazilsouth', label: 'Brazil South' },
    { value: 'francecentral', label: 'France Central' },
    { value: 'francesouth', label: 'France South' },
    { value: 'uksouth', label: 'UK South' },
    { value: 'ukwest', label: 'UK West' },
    { value: 'germanycentral', label: 'Germany Central' },
    { value: 'germanynortheast', label: 'Germany Northeast' },
    { value: 'germanywestcentral', label: 'Germany West Central' },
    { value: 'germanynorth', label: 'Germany North' },
    { value: 'switzerlandnorth', label: 'Switzerland North' },
    { value: 'switzerlandwest', label: 'Switzerland West' },
    { value: 'norwaywest', label: 'Norway West' },
    { value: 'norwayeast', label: 'Norway East' },
    { value: 'eastasia', label: 'East Asia' },
    { value: 'australiacentral', label: 'Australia Central' },
    { value: 'australiacentral2', label: 'Australia Central 2' },
    { value: 'australiasoutheast', label: 'Australia Southeast' },
    { value: 'chinaeast', label: 'China East' },
    { value: 'chinanorth', label: 'China North' },
    { value: 'chinaeast2', label: 'China East 2' },
    { value: 'chinanorth2', label: 'China North 2' },
    { value: 'centralindia', label: 'Central India' },
    { value: 'southindia', label: 'South India' },
    { value: 'westindia', label: 'West India' },
    { value: 'japaneast', label: 'Japan East' },
    { value: 'japanwest', label: 'Japan West' },
    { value: 'koreacentral', label: 'Korea Central' },
    { value: 'koreasouth', label: 'Korea South' },
    { value: 'southafricanorth', label: 'South Africa North' },
    { value: 'southafricawest', label: 'South Africa West' },
    { value: 'uaecentral', label: 'UAE Central' },
    { value: 'uaenorth', label: 'UAE North' },


];

export const getVolumesStatistics = volumes => ({
    volumesCount: volumes && volumes.length,
    regionsCount: volumes && _(volumes).countBy('region').keys().value().length,
    volumesCountByRegion: volumes && _.countBy(volumes, 'region'),
    totalAllocatedBytes: volumes && _.sumBy(volumes, 'quotaInBytes'),
    totalUsedBytes: volumes && _.sumBy(volumes, 'usedBytes')
});

export const parseRegionsData = urlSearch => {
    const search = querystring.parse(urlSearch);
    if (!search){
        throw new Error("Regions data was not supplied")
    }
    // history.replace(window.location.pathname);
    return JSON.parse(atob(search.regionsData));
};

export const filterVolumes = (volumes, filterString) => {
    if (!filterString) return volumes;
    return _.filter(volumes, ({ name, region }) => name.toLowerCase().includes(filterString) || region.toLowerCase().includes(filterString));
};

export const filterAnfVolumes = (volumes, filterString) => {
    if (!filterString) return volumes;
    return _.filter(volumes, ({ properties, location }) => properties.name.toLowerCase().includes(filterString) || location.toLowerCase().includes(filterString));
};

export const azureStateMap = {
    "Succeeded": "available",
    "Failed": "disabled",
    "Creating": "creating",
    "Deleting": "deleting",
    "Error":"error"
};

export const parseAnfVolume = ({ volume }) => {
    const locationDisplayName = _.find(azureAvailableRegions,{value: volume.placement.location});
    return({
        name: volume.name,
        lifeCycleState: azureStateMap[volume.properties.state],
        lifeCycleStateDetails: "",
        region: volume.placement.location,
        regionDisplayName: locationDisplayName ? locationDisplayName.label : volume.placement.location,
        fileSystemId: volume.properties.fileSystemId || uuidv4(),
        quotaInBytes: volume.properties.usageThreshold,
        usedBytes: volume.properties.usedSize || 0,
        serviceLevel: volume.properties.serviceLevel,
        ipAddress: volume.properties.mountIp,
        subscription: volume.placement.subscriptionId,
        capacityPoolName: volume.placement.pool,
        capacityPoolSize: volume.placement.poolsize,
        netappAccountName: volume.placement.account,
        resourceGroupName: volume.placement.resourceGroup,
        protocols: volume.properties.protocols,
        isCifs: volume.properties.protocols? volume.properties.protocols.includes("CIFS"):null,
        creationToken: volume.properties.creationToken,
        smbServerFQDN: volume.properties.smbServerFQDN,
        provider: "anf"
    })
};

export const providerIdMap = {
    'aws': 'fileSystemId',
    'anf': 'fileSystemId'
};
